/*
 * Copyright (c) 2002-2017 "Neo Technology,"
 * Network Engine for Objects in Lund AB [http://neotechnology.com]
 *
 * This file is part of Neo4j.
 *
 * Neo4j is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export default [
  'ACCESS',
  'ACTIVE',
  'ADMIN',
  'ADMINISTRATOR',
  'ALL',
  'ALLSHORTESTPATHS',
  'ALTER',
  'AND',
  'ANY',
  'AS',
  'ASC',
  'ASCENDING',
  'ASSERT',
  'ASSIGN',
  'BOOSTED',
  'BRIEF',
  'BTREE',
  'BUILT',
  'BY',
  'CALL',
  'CASE',
  'CATALOG',
  'CHANGE',
  'COMMIT',
  'CONSTRAINT',
  'CONSTRAINTS',
  'CONTAINS',
  'COPY',
  'COUNT',
  'CREATE',
  'CSV',
  'CURRENT',
  'CYPHER',
  'DATABASE',
  'DATABASES',
  'DBMS',
  'DEFAULT',
  'DEFINED',
  'DELETE',
  'DENY',
  'DESC',
  'DESCENDING',
  'DETACH',
  'DISTINCT',
  'DROP',
  'EACH',
  'ELEMENT',
  'ELEMENTS',
  'ELSE',
  'END',
  'ENDS',
  'EXECUTABLE',
  'EXECUTE',
  'EXIST',
  'EXISTENCE',
  'EXISTS',
  'EXPLAIN',
  'EXTRACT',
  'FALSE',
  'FIELDTERMINATOR',
  'FILTER',
  'FOR',
  'FOREACH',
  'FROM',
  'FULLTEXT',
  'FUNCTION',
  'FUNCTIONS',
  'GRANT',
  'GRAPH',
  'GRAPHS',
  'HEADERS',
  'HOME',
  'IF',
  'IN',
  'INDEX',
  'INDEXES',
  'IS',
  'JOIN',
  'KEY',
  'LABEL',
  'LABELS',
  'LIMIT',
  'LOAD',
  'LOOKUP',
  'MANAGEMENT',
  'MATCH',
  'MERGE',
  'NAME',
  'NAMES',
  'NEW',
  'NODE',
  'NODES',
  'NONE',
  'NOT',
  'NULL',
  'OF',
  'ON',
  'OPTIONAL',
  'OPTIONS',
  'OR',
  'ORDER',
  'OUTPUT',
  'PASSWORD',
  'PERIODIC',
  'POPULATED',
  'PRIVILEGES',
  'PROCEDURE',
  'PROCEDURES',
  'PROFILE',
  'PROPERTY',
  'READ',
  'REDUCE',
  'REL',
  'RELATIONSHIP',
  'RELATIONSHIPS',
  'REMOVE',
  'RENAME',
  'REPLACE',
  'REQUIRED',
  'RETURN',
  'REVOKE',
  'ROLE',
  'ROLES',
  'SCAN',
  'SET',
  'SHORTESTPATH',
  'SHOW',
  'SINGLE',
  'SKIP',
  'START',
  'STARTS',
  'STATUS',
  'STOP',
  'SUSPENDED',
  'THEN',
  'TO',
  'TRAVERSE',
  'TRUE',
  'TYPE',
  'TYPES',
  'UNION',
  'UNIQUE',
  'UNWIND',
  'USER',
  'USERS',
  'USING',
  'VERBOSE',
  'WHEN',
  'WHERE',
  'WITH',
  'WRITE',
  'XOR',
  'YIELD',
];



// WEBPACK FOOTER //
// ./node_modules/cypher-editor-support/src/lang/CypherKeywords.js